import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/usb': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M641.5 256c0 3.1-1.7 6.1-4.5 7.5l-89.1 53.5c-1.4 0.8-2.8 1.4-4.5 1.4-1.4 0-3.1-0.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6h-238.7c25.3 39.6 40.5 106.9 69.6 106.9h26.7v-26.8c0-5 3.9-8.9 8.9-8.9h89.1c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5h-100.3c-8.1 30.6-35.9 53.5-69 53.5-39.3-0.1-71.3-32.1-71.3-71.4s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4 40.1-89.1 58.1-82.1 108.9-82.1 7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5 0 29.6-23.9 53.5-53.5 53.5-23.4 0-42.9-14.8-50.4-35.6h-29.8c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8s6.4-1.4 8.9 0.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/usb.js
// module id = null
// module chunks = 